import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowDiagonalDownRightStyle0 = cosmosIconCss;

const CosmosIconArrowDiagonalDownRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalDownRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '758e21503207cde5d43254fde7a820c0578ad28f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b0f3b18239600a40863aa5d7c24374c0a57ee37a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '444221c09ce9749f5028ca86eec894f2b1da5ebc', d: "M13.59 14.65H9.14a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .356-.148.498.498 0 0 0 .149-.356v-6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.44l-7.579-7.58a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l7.584 7.583Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowDiagonalDownRightStyle0; }
}, [1, "cosmos-icon-arrow-diagonal-down-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-down-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-down-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalDownRight$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalDownRight = CosmosIconArrowDiagonalDownRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalDownRight, defineCustomElement };
